export const INTERNAL_HOSTS = [
  'toasttab.test',
  'inttoasttab.test',
  'toast.local',
  'mktg-toasttab-com.local',
  '104.236.26.20',
  'phrasingpro2.com',
  'www.toasttab.com',
  'careers.toasttab.com',
  'central.toasttab.com',
  'status.toasttab.com',
  'refer.toasttab.com',
  'pos.toasttab.com',
  'investors.toasttab.com',
  'localpartners.toasttab.com',
  's3.amazonaws.com',
  'd2w1ef2ao9g8r9.cloudfront.net',
  'partners.toasttab.com',
  'rallyforrestaurant.com',
  'share.vidyard.com',
  'toasttakeout.com',
  'rallyforestaurants.com',
  'rallyforrestaurant.com',
  'rallyforrestaurants.com',
  'rallyforrestaurants.org',
  'stratex.com',
  'toast.org',
  'toastgo.com',
  'toasttab.ca',
  'toastinc.com',
  'toast.inc',
  'buytoast.com',
  'toastforrestaurants.com',
  'toastforgood.org',
  'toastorderandpay.com',
  'toast-shop.com',
  '142.93.76.41',
  'xtrachef.com',
  'toasttab.local',
  'phrasingpro3.com',
  'staging.phrasingpro3.com',
  'staging-noncf.phrasingpro3.com',
  'prod.phrasingpro3.com',
  'intl.phrasingpro3.com',
  'dev.phrasingpro3.com',
  'dev-noncf.phrasingpro3.com',
  'localhost',
  '192.241.134.173',
  'dwhoejhfdw8er.cloudfront.net',
  'di8blgq856e7l.cloudfront.net',
  'd10bf60mhsuiwk.cloudfront.net',
  'd1offsmk3b6j6h.cloudfront.net',
  'dev-craft-preview.phrasingpro3.com',
  'staging-craft-preview.phrasingpro3.com',
  'pos-craft-preview.phrasingpro3.com',
  'd2ibudjvyslmx1.cloudfront.net',
  'contentful-dev-proxy.phrasingpro3.com',
  'contentful-staging-proxy.phrasingpro3.com',
  'contentful-pos-proxy.phrasingpro3.com',
  'contentful-dev.phrasingpro3.com',
  'contentful-staging.phrasingpro3.com',
  'contentful-preview.phrasingpro3.com',
  'contentful-preview-dev.phrasingpro3.com',
  'contentful-preview-staging.phrasingpro3.com',
  'contentful-preview-master.phrasingpro3.com',
  'contentful-otl-preview-dev.phrasingpro3.com',
  'contentful-otl-preview-staging.phrasingpro3.com',
  'contentful-otl-preview-master.phrasingpro3.com',
  'contentful-pos.phrasingpro3.com',
  'dzlubb12xa1bc.cloudfront.net',
  'community.toasttab.com', // Playground Contentful Cloudfront Distribution
  'staging-support.phrasingpro3.com', // Staging Support
  'staging-support-preview.phrasingpro3.com', // Staging Preview
  'support.toasttab.com', // Production Support
  'apps.apple.com',
  'play.google.com',
  'toasttab.com',
  'support.phrasingpro3.com',
  'support.preview.phrasingpro3.com',
  'support.toasttab.com',
  'payroll.toasttab.com'
]
